import { render, staticRenderFns } from "./LikedProduct.html?vue&type=template&id=1979b794&scoped=true&"
import script from "./LikedProduct.vue?vue&type=script&lang=js&"
export * from "./LikedProduct.vue?vue&type=script&lang=js&"
import style0 from "./LikedProduct.scss?vue&type=style&index=0&id=1979b794&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1979b794",
  null
  
)

export default component.exports